<ng-container *ngIf="noOrgEquipment">
    <div class="empty-page">
        <mat-icon>warning</mat-icon>
        <h2>{{ 'equipment.list.none_found' | translate }}</h2>
    </div>
</ng-container>

<ng-container *ngIf="loading">
    <div class="empty-page">
        <mat-spinner diameter="60"></mat-spinner>
        <h2>{{ 'equipment.loading' | translate }}...</h2>
    </div>
</ng-container>
